import { Component, OnInit } from '@angular/core';
import { NavService } from '../../core/services/nav.service';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss']
})
export class PublicLayoutComponent implements OnInit {

  constructor(public _navService: NavService) { }

  ngOnInit(): void {
  }

}
